import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { carwashTrolleys } from '../data/products';
import './CarWashTrolley.css';

const CarWashTrolley = ({ onAddToCart }) => {
  const [searchTerm, setSearchTerm] = useState('');

  // Filter trolleys based on search term
  const filteredTrolleys = carwashTrolleys.filter(trolley => {
    return trolley.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
           trolley.description.toLowerCase().includes(searchTerm.toLowerCase());
  });

  return (
    <div className="trolley-page">
      <div className="trolley-hero section">
        <div className="container">
          <div className="section-title">
            <h5>Car Wash Trolleys</h5>
            <h2>Professional Mobile Car Wash Equipment</h2>
            <p>Discover our range of innovative car wash trolleys designed for professional mobile car cleaning services. Built with durability and efficiency in mind.</p>
          </div>
        </div>
      </div>

      <div className="trolley-content section">
        <div className="container">
          {/* Search Filter */}
          <div className="trolley-filters">
            <div className="search-filter">
              <input
                type="text"
                placeholder="Search trolleys..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
            </div>
          </div>

          {/* Trolleys Grid */}
          <div className="trolleys-grid">
            {filteredTrolleys.length > 0 ? (
              filteredTrolleys.map(trolley => (
                <div key={trolley.id} className="trolley-card">
                  <div className="trolley-image">
                    <img src={`/${trolley.image}`} alt={trolley.title} />
                    <div className="trolley-overlay">
                      <Link to={`/trolley/${trolley.id}`} className="btn btn-primary">
                        View Details
                      </Link>
                    </div>
                  </div>
                  <div className="trolley-info">
                    <div className="trolley-category">{trolley.category}</div>
                    <h3 className="trolley-product-title" title={trolley.title}>{trolley.title}</h3>
                    {/* <p className="trolley-description">{trolley.description}</p> */}
                    <div className="trolley-brand">
                      <span>Brand: {trolley.brand}</span>
                    </div>
                    {/* <div className="trolley-price">Price: ${trolley.price}</div> */}
                    {/* <div className="trolley-specs">
                      {trolley.details.ProductSize && (
                        <div className="spec-item">
                          <strong>Product Size:</strong> {trolley.details.ProductSize}
                        </div>
                      )}
                      {trolley.details.PackageSize && (
                        <div className="spec-item">
                          <strong>Package Size:</strong> {trolley.details.PackageSize}
                        </div>
                      )}
                    </div> */}
                    <Link to={`/trolley/${trolley.id}`} className="btn btn-primary" style={{width: '100%', marginTop: '10px'}}>
                      Learn More
                    </Link>
                  </div>
                </div>
              )) 
            ) : (
              <div className="no-trolleys">
                <h3>No trolleys found</h3>
                <p>Try adjusting your search criteria.</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Features Section */}
      <section className="trolley-features section" style={{ background: '#f7fafd' }}>
        <div className="container">
          <div className="section-title">
            <h2>Why Choose Our Car Wash Trolleys?</h2>
          </div>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-tools"></i>
              </div>
              <h4>Professional Quality</h4>
              <p>Built with durable materials and professional-grade components for long-lasting performance.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-mobile-alt"></i>
              </div>
              <h4>Mobile Design</h4>
              <p>Designed for easy mobility with rubberized wheels and compact construction for convenient transport.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-leaf"></i>
              </div>
              <h4>Eco-Friendly</h4>
              <p>Water-efficient design with separate drainage tanks to minimize environmental impact.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-battery-full"></i>
              </div>
              <h4>Power Efficient</h4>
              <p>12V battery operation with optimized power consumption for extended working hours.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CarWashTrolley; 